import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import CTASection from './components/CTASection';
import TrendingGrid from './components/TrendingGrid';
import Testimonials from './components/Testimonials';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <AboutSection />
        <CTASection />
        <TrendingGrid />
        <Testimonials />
      </main>
      <Footer />

      {/* Schema.org structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'Superbuy Spreadsheet',
            url: 'https://superbuyspread.living',
            description: 'The ultimate resource hub for Superbuy Spreadsheet product finds, QC guides, and shopping tips for international shoppers.',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://superbuyspread.living/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
    </>
  );
}